import React, { useContext } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { GeneralDataContext } from '../State/GeneralDataContext';
import {
  cmsFlag,
  cmsText,
  DEFAULT_DEVELOPMENT_BANNER_TEXT,
} from '../utils/cmsCopy';
import './DevelopmentBanner.css';

/**
 * Discrete development notice for the home hero (bottom-right).
 * Visibility and text: WP → Website General Data
 * (show_development_banner, development_banner_text).
 */
const DevelopmentBanner = () => {
  const { data: generalData } = useContext(GeneralDataContext);
  const show = cmsFlag(generalData?.show_development_banner, false);
  if (!show) return null;

  const text = cmsText(generalData?.development_banner_text, DEFAULT_DEVELOPMENT_BANNER_TEXT);

  return (
    <aside className="development-notice" role="status" aria-live="polite">
      <i
        className="bi bi-exclamation-triangle-fill development-notice__icon"
        aria-hidden="true"
      />
      <p className="development-notice__text">{text}</p>
    </aside>
  );
};

export default DevelopmentBanner;
